import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'

const AppForm = ({
  values,
  handleChange,
  errors,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='policy_type_name'
          name='policy_type_name'
          colSize='6'
          inputLabel='Policy Type Name'
          className='mb-3'
          placeholder='Enter policy type name...'
          value={values.policy_type_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.policy_type_name}
          invalid={errors.policy_type_name}
        />
        <FormTextAreaInput
          id='policy_type_description'
          name='policy_type_description'
          colSize='6'
          inputLabel='Policy Type Description'
          className='mb-3'
          placeholder='Enter policy type description...'
          rows='5'
          value={values.policy_type_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.policy_type_description}
          invalid={errors.policy_type_description}
        />
      </CRow>
    </>
  )
}

export default AppForm